import { format } from 'date-fns'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import type { AdminUserListItem } from '@/types/admin'

function formatDateTime(iso: string | null): string {
  if (!iso) return '–'
  return format(new Date(iso), 'yyyy-MM-dd HH:mm')
}

interface InfoRowProps {
  label: string
  children: React.ReactNode
}

function InfoRow({ label, children }: InfoRowProps) {
  return (
    <div className="flex justify-between gap-4 py-1.5 text-sm">
      <span className="text-muted-foreground">{label}</span>
      <span className="text-right break-all">{children}</span>
    </div>
  )
}

interface AdminUserInfoCardProps {
  user: AdminUserListItem
}

export function AdminUserInfoCard({ user }: AdminUserInfoCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Kontouppgifter</CardTitle>
      </CardHeader>
      <CardContent className="divide-y">
        <InfoRow label="E-post">{user.email || '–'}</InfoRow>
        <InfoRow label="Namn">{user.displayName || '–'}</InfoRow>
        <InfoRow label="Företagsnamn">{user.companyName || '–'}</InfoRow>
        <InfoRow label="Organisationsnummer">
          {user.organizationNumber || '–'}
        </InfoRow>
        <InfoRow label="Skapad">{formatDateTime(user.createdAt)}</InfoRow>
        <InfoRow label="Senast inloggad">
          {formatDateTime(user.lastSignInAt)}
        </InfoRow>
        <InfoRow label="Profil">
          <Badge variant={user.profileCompleted ? 'default' : 'secondary'}>
            {user.profileCompleted ? 'Komplett' : 'Ofullständig'}
          </Badge>
        </InfoRow>
        <InfoRow label="Konto">
          <Badge variant={user.disabled ? 'destructive' : 'default'}>
            {user.disabled ? 'Avstängt' : 'Aktivt'}
          </Badge>
        </InfoRow>
        <InfoRow label="UID">
          <code className="text-xs">{user.uid}</code>
        </InfoRow>
      </CardContent>
    </Card>
  )
}
